export const enum GoogleAnalyticsPage {
  SERVICES = 'pageServices',
  CHECKOUT = 'pageCheckout',
  PAYMENT = 'pagePayment',
}

export const enum GoogleAnalyticsButton {
  CHECKOUT = 'Checkout',
  CONTACT_CEMETERY = 'Contact_Cemetery',
  GO_TO_PAYMENT = 'Go_To_Payment',
  BACK = 'Back',
  MAKE_PAYMENT = 'Make_Payment',
}
